import { Component, HostListener } from '@angular/core';
import { RouterOutlet } from '@angular/router';
// import { UserIdleService } from 'angular-user-idle';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Location } from "@angular/common";
import { AuthenticationService } from './authentication.service';
import { CommonService } from './common.service';
import { filter, map } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: true
})
export class AppComponent {
  title = 'stream-peak-client';
  public param1: any = {};
  public param2: any = {};
  public param3: any = {};

  constructor(private http: HttpClient, private router: Router, private location: Location,
    // private userIdle: UserIdleService,
    private auth: AuthenticationService, private common: CommonService, private activatedRoute: ActivatedRoute,
    private titleService: Title) {
    this.param1 = 'code';
    this.param2 = 'email';
    this.param3 = 'lead';
    const url = window.location.href;
    let code = this.common.getParamValueQueryString(this.param1, url);
    let email = this.common.getParamValueQueryString(this.param2, url);
    let lead = this.common.getParamValueQueryString(this.param3, url);
    //to get session
    const is_login = this.auth.do_getSession_Data('session_login');
    if (is_login) {
      if (this.location.path() == '/login') {
        this.router.navigate([this.auth.getDefaultLandingRoute(this.auth.do_getSession_Data('session_role'))]);
      } else {
        this.router.navigate([this.location.path()]);
      }
    } else {
      if (url.includes('?')) {//query sting
        if (lead !== null) {
          this.router.navigate(['leads/reviews'], { queryParams: { code: code, 'lead': lead } });
        } else {
          if (email && code) {
            this.router.navigate(['login/reset-password'], { queryParams: { code: code, 'email': email } });
          } else {
            this.router.navigate(['otp-verification'], { queryParams: { email: email } });
          }
        }
      } else {
        this.router.navigate(['/login']);
      }
    }
  }

  ngOnInit() {
    const appTitle = this.titleService.getTitle();
    // console.log(appTitle);
    this.router
      .events.pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {
          const child: any = this.activatedRoute.firstChild;
          if (child.snapshot.data['title']) {
            return child.snapshot.data['title'];
          }
          return appTitle;
        })
      ).subscribe((pageTitle: string) => {
        this.titleService.setTitle(pageTitle);
      });
    console.log('ok')
    // Start watching for user inactivity.
    // this.userIdle.startWatching();

    // // // Start watching when user idle is starting.
    // this.userIdle.onTimerStart().subscribe(count => console.log(count));

    // // // Start watch when time is up.
    // this.userIdle.onTimeout().subscribe(() => this.auth.doLogout());
    // console.log(this.userIdle)
  }

  // @HostListener('window:mousemove')
  // @HostListener('window:keydown')
  // @HostListener('window:click')
  // resetTimer() {
  //   this.userIdle.resetTimer();
  // }
}
